import React from 'react'
import { BaseSchema } from '../../../Schema/BaseSchema'
import { CountryRegionPicker } from '../CountryRegionPicker'

interface SchemaCountryRegionPickerProps {
  countryCode: string
  className?: any
  schema: BaseSchema
  label?: string
  field?: string
  helperText?: string
  onChange: Function
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  enableCreate?: boolean
}

export const SchemaCountryRegionPicker: React.FC<SchemaCountryRegionPickerProps> = ({
  countryCode,
  className,
  schema,
  field = 'state',
  label = 'State/Province/Region',
  helperText,
  onChange = (value: string, field: string) => {},
  disabled,
  required,
  variant,
  placeholder = 'Select a State/Province/Region',
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate,
}) => {
  return (
    <CountryRegionPicker
      countryCode={countryCode}
      className={className}
      label={label}
      onChange={value => onChange(value, field)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      error={schema.isPropertyInvalid(field)}
      helperText={schema.isPropertyInvalid(field) ? schema.getPropertyError(field) : helperText }
      value={schema.getValue(field) || null}
    />
  )
}
